<template>
  <v-dialog
    v-model="localDialog"
    max-width="500px"
    @keydown.esc="$emit('close', false)"
    persistent
  >
    <v-card>
      <v-card-title class="headline">Confirmation</v-card-title>
      <v-divider class="mb-2"></v-divider>
      <v-card-text>{{ text }}</v-card-text>
      <v-card-actions>
        <v-btn color="primary darken-1" @click="$emit('close', false)"
          >No</v-btn
        >
        <v-btn
          color="success darken-1"
          @click="$emit('confirm', true)"
          :loading="loader"
          >Yes</v-btn
        >
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "Are you sure you want to delete this item?",
    },
    loader: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localDialog: false,
    };
  },
  watch: {
    dialog(newVal) {
      this.localDialog = newVal;
    },
  },
};
</script>
<style lang="scss" scoped>
.v-card__title {
  word-break: break-word !important;
}
</style>
